import React, { FC } from 'react'
import classNames from 'classnames'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Box } from 'transfix-ui/core'
import { STOP_TYPE } from 'apps/fleet-planner/constants/loads'
import { IStop, AuctionShipmentPickupOrDelivery } from 'apps/fleet-planner/types'
import { capitalize } from 'utils/capitalize'
import 'scss/5_components/_stops-divider.scss'

interface IStopsDividerProps {
  stops: (IStop | AuctionShipmentPickupOrDelivery)[]
  dataTest?: string
}

/**
 * @deprecated Use the one in components/StopsDivider, version without SASS
 */
export const StopsDivider: FC<IStopsDividerProps> = ({ stops = [], dataTest }) => {
  const stopsBetween = stops.length - 2
  const isMultiStop = stopsBetween > 0

  const numberContainerClasses = classNames(
    'rounded',
    'ph1',
    'flex',
    'flex-row',
    'items-center',
    'bg-coolGray5',
    'text-inverse'
  )

  const hrClasses = classNames('bg-coolGray5')

  return isMultiStop ? (
    <Tooltip
      type='light'
      position='bottom'
      effect='solid'
      trigger={
        <Box className='stops-divider flex flex-row items-center pt3' data-test={dataTest}>
          <hr className={hrClasses} />
          <span className={numberContainerClasses}>{stopsBetween}</span>
          <hr className={hrClasses} />
        </Box>
      }>
      <div data-test='stops-tooltip-content'>
        {stops.map((stop: IStop | AuctionShipmentPickupOrDelivery, idx) => {
          const { city, stateCode, stopSequence, stopType } = stop || {}
          const cityName = capitalize(city)
          const containerClasses = classNames('flex flex-row items-center', {
            mb3: idx < stops.length - 1,
          })
          return (
            <div key={`${stopType}${stopSequence}`} className={containerClasses}>
              <div className='mr3'>
                <MapMarker mini sequence={stopSequence} type={stopType as STOP_TYPE} />
              </div>
              <div>
                <div className='text-caption-semibold text-default'>
                  {cityName}, {stateCode}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Tooltip>
  ) : (
    <Box className='stops-divider-single flex flex-row items-center pt3' data-test={dataTest}>
      <hr className={hrClasses} />
    </Box>
  )
}
